import React, {FC, useEffect, useState, useCallback} from 'react';
import {useSelector} from 'react-redux';
import {IconButton} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import {Media, Modal, ModalHeader, ModalBody, Card, CardBody} from 'reactstrap';
import {createLoadingSelector} from '../../../selectors/loading';
import {LoadingIndicator} from '../../LoadingIndicator';
import {EDIT_DEALER} from '../../../store/dealer/actionTypes';
import {DealerForm} from '../DealerForm';

interface DealerCardProps {
  dealer?: FullDealer;
  isLoading?: boolean;
}

export const DealerCard: FC<DealerCardProps> = ({dealer, isLoading}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalIsLoading, setModalIsLoading] = useState(false);

  const loadingSelector = useSelector(createLoadingSelector([EDIT_DEALER]));

  useEffect(() => {
    setModalIsLoading(loadingSelector);
  }, [loadingSelector]);

  const toggleModal = useCallback(() => setModalOpen((prev) => !prev), []);

  return (
    <Card>
      <CardBody>
        <Media>
          <Media body>
            <h4 className="card-title">Dealer</h4>
            {isLoading ? (
              <LoadingIndicator />
            ) : dealer ? (
              <div>
                <h5>{dealer.name}</h5>
                <p className="text-muted mb-1">
                  {dealer.street} {dealer.street_no}
                </p>
                <p className="text-muted mb-1">
                  {dealer.zip_code} {dealer.city}
                </p>
                <p className="text-muted mb-1">{dealer.country}</p>
              </div>
            ) : (
              <p className="text-muted">No dealer data</p>
            )}
          </Media>
          <div className="avatar-sm">
            <IconButton aria-label="edit" onClick={toggleModal} disabled={isLoading}>
              <EditIcon />
            </IconButton>
            <Modal
              size="lg"
              isOpen={modalOpen}
              toggle={toggleModal}
              autoFocus
              centered
              className="dealerEditModal"
            >
              <ModalHeader toggle={toggleModal}>
                Edit Dealer {modalIsLoading && <LoadingIndicator />}
              </ModalHeader>
              <ModalBody>{dealer && <DealerForm dealer={dealer} />}</ModalBody>
            </Modal>
          </div>
        </Media>
      </CardBody>
    </Card>
  );
};
